import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=3c01f1ec&scoped=true"
import script from "./Header.vue?vue&type=script&lang=tsx"
export * from "./Header.vue?vue&type=script&lang=tsx"
import style0 from "./Header.vue?vue&type=style&index=0&id=3c01f1ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c01f1ec",
  null
  
)

export default component.exports